// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M.752 12.456l2.792 2.792L0 16l.752-3.544zM15.8 15.6c.11 0 .2.09.2.2 0 .11-.09.2-.2.2H5.4c-.11 0-.2-.09-.2-.2 0-.11.09-.2.2-.2h10.4zM13.208 0L16 2.792 4.188 14.604l-2.792-2.792L13.208 0z\"/> </svg> ";
// Exports
module.exports = code;